<template>
  <sc-render :fields="fields" :emptyMessage="$t('NO_DATA_SOURCE_EXIST')">
    <div class="image-collage" :class="{'editorial-height': isExperienceEditor}">
      <div class="image-container"
           v-if="hasImages"
           :class="{'landscape-portrait': fields.imagesAlignment.value === 'landscapePortrait'}"
      >
        <div class="image image-portrait">
          <sc-image v-if="isExperienceEditor"
                    :media="fields.portraitImage"/>
          <picture v-if="!isExperienceEditor">
            <img class="img-portrait" :src="fields.portraitImage.value.cloudinary_3x4_fill_crop" :alt="fields.portraitImage.value.alt"/>
          </picture>
        </div>
        <div class="image image-landscape">
          <sc-image v-if="isExperienceEditor"
                    :media="fields.landscapeImage"/>
          <picture v-if="!isExperienceEditor">
            <img class="img-landscape" :src="fields.landscapeImage.value.cloudinary_4x3_fill_crop" :alt="fields.landscapeImage.value.alt"/>
          </picture>
        </div>
      </div>
    </div>
  </sc-render>
</template>

<script>

import { Image as ScImage } from '@sitecore-jss/sitecore-jss-vue'
import { ShImage } from '@sohohouse/design-system'
import { createNamespacedHelpers } from 'vuex'
import get from '~/helpers/get'
import ScRender from '../sc-render/'

const { mapState: mapJssState } = createNamespacedHelpers('jss')

export default {
  name: 'TwoImageGallery',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScImage,
    ScRender,
    ShImage
  },
  computed: {
    ...mapJssState(['isExperienceEditor']),
    hasImages () {
      return Boolean(
        get(this.fields, ['portraitImage', 'value']) &&
        get(this.fields, ['landscapeImage', 'value'])
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.editorial-height {
  min-height: 200px;
}
.image-collage{
  display: flex;
  justify-content: center;
  margin: $space-100 0;

  .image-container{
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 0 $space-080;
  }
  .landscape-portrait{
    .image-portrait{
      order: 1;
      margin-right: 0;
    }
    .image-landscape{
      order: 0;
      margin-right: $space-080;
    }
  }
  img{
    display: block;
    width: 100%;
  }
  .image {
    ::v-deep .sc-image-wrapper img {
      width: 100%;
      height: auto;
    }
  }
  .image-portrait{
    margin-right: $space-080;
  }
  .image-landscape{
    margin-bottom: $space-080;
  }
  @include desktop{
    .image-container{
      padding: 0 $space-120;
    }
    .image-portrait{
      margin-right: $space-120;
    }
    .landscape-portrait{
      .image-portrait{
        margin-right: 0;
      }
      .image-landscape{
        margin-right: $space-120;
      }
    }
  }
  @include mobile{
    .image-container{
      display: block;
      width: 100%;
      padding: 0;
    }
    .landscape-portrait{
      display: flex;
      flex-wrap: wrap;

      .image-landscape{
        margin-bottom: $space-090;
        margin-right: $space-110;
      }
      .image-portrait{
        margin-bottom: 0;
      }
    }
    .image:first-of-type{
      margin-right: auto;
    }
    .image-portrait{
      width: 255px;
      margin: 0 auto;
      margin-bottom: $space-090;
    }
    .image-landscape{
      margin-left: $space-050;
      margin-right: $space-110;
      margin-bottom: 0;
    }
  }
}
</style>
